import axiosInstance from "../server/axios"

const token = localStorage.getItem('authToken')

export const validateUserData = async (data) => {
    const response = await axiosInstance.post(`/validate-user`, data, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${token}`
        },
    });
    return response;
}

export const storeAchatFromClientDetailled = (data) => {
    const token = localStorage.getItem('authToken')
    return axiosInstance.post(`/achat-detailled`, data, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${token}`
        },
    });
}
export const create_empty_achat = (data) => {
    const token = localStorage.getItem('authToken')
    return axiosInstance.post(`/create-empty-achat`, data, {
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
    });
}

export const getAchatById = (id) => {
    const token = localStorage.getItem('authToken');
    return axiosInstance.get(`/get-achat-by-id/${id}`, {
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
    });
};

export const processPayment = (data) => {
    const token = localStorage.getItem('authToken')
    return axiosInstance.post(`/process-payment`, data, {
        headers: { 
            'Authorization': `Bearer ${token}`
        
        }
    });
}